/* eslint-disable */
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import Item from "../../utils/Item";
import PrecioVentaContadoLista from "./PrecioVentaContadoLista";

//
// ###########################################################################
//
const DatosBlock = ({ articulo, showPrecio = true }) => {

  //
  // ################################################################################
  //
  return (
    <>
      {articulo && (
        <>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Block
              </Typography>

              <Grid container spacing={2}>
                <Item label="Producto" value={articulo.descripcion_block_producto} />
                <Item label="Descripción" value={articulo.descripcion} />
                <Item label="Modelo" value={articulo.modelo} />
                <Item label="Marca" value={articulo.descripcion_bl_cr_marca} />
                <Item label="Material" value={articulo.descripcion_bl_cr_material} />
                <Item label="Tipo" value={articulo.descripcion_bl_cr_tipo} />
                <Item label="Color" value={articulo.descripcion_bl_cr_color} />
                <Item label="Adición" value={articulo.valor_bl_cr_adicion} />
                <Item label="Curva" value={articulo.valor_bl_curva} />
                <Item label="Diámetro" value={articulo.valor_bl_cr_diametro} />
                <Item label="Espesor" value={articulo.valor_bl_espesor} />
                <Item label="Ojo" value={articulo.ojo} />
              </Grid>
            </CardContent>
          </Card>

          {showPrecio && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <PrecioVentaContadoLista precioVentaContado={articulo.precio_venta_contado} precioVentaLista={articulo.precio_venta_lista} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default DatosBlock;
